import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SubscriptionLandingPage from "./SubscriptionLandingPage";

const SubscriptionRemainder = () => {
  const currentTermEndsAt = useSelector(
    (state: any) => state.sub.currentTermEndsAt
  );
  const subscription = useSelector((state: any) => state.sub.subscription);
  const cardDetailsStatus = useSelector(
    (state: any) => state.sub.cardDetailsStatus
  );
  const fromZohoPaymetntsPage = useSelector(
    (state: any) => state.sub.fromZohoPaymetntsPage
  );
  const [showRemainder, setShowRemainder] = useState(true);
  const [daysRemaining, setDaysRemaining] = useState<number | null>(null);
  const [openSubscriptionDialog, setOpenSubscriptionDialog] = useState(false);
  const handleSubscriptionClose = () => {
    setOpenSubscriptionDialog(false);
  };
  useEffect(() => {
    if (currentTermEndsAt) {
      const currentDate = new Date();
      const currentTermEndAt = new Date(currentTermEndsAt);
      const timeDifference = currentTermEndAt.getTime() - currentDate.getTime();
      const daysRemaining = Math.floor(timeDifference / (1000 * 3600 * 24)) + 1;
      setDaysRemaining(Math.max(0, daysRemaining));
    }
  }, [currentTermEndsAt]);
  return (
    <Fragment>
      {subscription?.status === "trial" &&
        cardDetailsStatus === "Not Provided" &&
        !fromZohoPaymetntsPage &&
        showRemainder &&
        daysRemaining !== null &&
        daysRemaining >= 0 &&
        daysRemaining <= 30 && (
          <div className="w-56 h-36 px-3 mx-2 mb-4 py-4 bg-neutral-800 rounded-lg flex-col justify-start items-start gap-2 inline-flex">
            <div className="self-stretch justify-between items-start inline-flex">
              <div className="w-48 text-white text-sm font-bold font-['Proxima Nova']">
                {daysRemaining + (daysRemaining === 1 ? " day" : " days")} left!
              </div>
              <img
                src="assets/icons/close.svg"
                alt=" "
                className="cursor-pointer"
                onClick={() => {
                  setShowRemainder(false);
                }}
              />
            </div>
            <div className="w-48 text-neutral-300 text-xs font-normal font-['Proxima Nova']">
              Your free trial expires in{" "}
              {daysRemaining + (daysRemaining === 1 ? " day" : " days")}, buy
              now to continue using Planetwise.
            </div>
            <div
              className="self-stretch bg-green-500 rounded justify-center items-center inline-flex cursor-pointer"
              onClick={() => {
                setOpenSubscriptionDialog(true);
              }}
            >
              <div className="w-full h-7 px-4 py-1 justify-center items-center gap-2 flex">
                <div className="text-white text-xs font-bold font-['Proxima Nova']">
                  Subscribe Now
                </div>
              </div>
            </div>
          </div>
        )}
      {openSubscriptionDialog && (
        <SubscriptionLandingPage
          open={openSubscriptionDialog}
          onClose={handleSubscriptionClose}
          showCloseIcon={true}
        />
      )}
    </Fragment>
  );
};

export default SubscriptionRemainder;
